import { HTMLProps } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import * as Styles from './DeleteButton.styles';

const DeleteButton = (
  props: Omit<HTMLProps<HTMLButtonElement>, 'children' | 'ref' | 'type' | 'as'>
): JSX.Element => (
  <Styles.DeleteBtn {...props}>
    <DeleteIcon />
    Delete
  </Styles.DeleteBtn>
);

export default DeleteButton;
